import { Radio, Tabs, Typography } from "antd";
import { comparisonOptions, lastYearOnlyRanges } from "./deltaFormat";

const { Text } = Typography;

const timeRangeOptions = ["30d", "60d", "90d", "365d", "YTD"];
const typeItems = [
  { key: "all", label: "All" },
  { key: "newBusiness", label: "New Business" },
  { key: "renewal", label: "Renewals" },
];

const FilterBar = ({
  timeRange,
  type,
  comparison,
  onTimeRangeChange,
  onTypeChange,
  onComparisonChange,
}) => {
  const lastYearOnly = lastYearOnlyRanges.includes(timeRange);
  const compareOptions = comparisonOptions.map((option) =>
    option.value === "previous" && lastYearOnly
      ? {
          ...option,
          disabled: true,
          title: `${timeRange} is only compared with last year`,
        }
      : option,
  );

  return (
    <div className="dashboard-filter-bar">
      <div className="filter-period-row">
        <div className="filter-group">
          <Text className="filter-label">
            Period <span style={{ color: "#ff4d4f" }}>*</span>
          </Text>
          <Radio.Group
            options={timeRangeOptions}
            value={timeRange}
            onChange={(e) => onTimeRangeChange(e.target.value)}
            optionType="button"
            buttonStyle="solid"
            size="middle"
          />
        </div>
        <div className="filter-group">
          <Text className="filter-label">
            Compare to <span style={{ color: "#ff4d4f" }}>*</span>
          </Text>
          <Radio.Group
            options={compareOptions}
            value={comparison}
            onChange={(e) => onComparisonChange(e.target.value)}
            optionType="button"
            buttonStyle="solid"
            size="middle"
          />
        </div>
      </div>
      <Tabs
        activeKey={type}
        onChange={onTypeChange}
        items={typeItems}
        size="small"
        // type="card"
        style={{ marginBottom: 0, marginTop: 16 }}
      />
    </div>
  );
};

export default FilterBar;
